<template>
  <PopupPicker
    v-model:show="innerShow"
    v-model:searchValue="searchValue"
    title="选择位置"
    :columns="columns"
    :columns-field-names="{
      text: 'true_place_name',
      value: 'id',
      children: 'lists'
    }"
    @search="onSearch"
    @confirm="onConfirm"
    @open="getColumns"
  >
    <template #fixedItem>
      <template v-if="historySearchValue">
        <div class="search-value h-50 text-theme pl-15 flex items-center" @click="historySearchValueClick">
          {{ historySearchValue }}
        </div>
        <div class="bg-page h-10"></div>
      </template>
      <template v-if="relationPlace?.length > 0">
        <div class="bg-white">
          <div class="pl-15 flex items-center border-solid border-0 border-b-[1px] border-[#E1E3E5]">
            <div class="flex-1 h-50 flex items-center">客户关联位置</div>
            <div
              class="flex justify-center items-center w-[42px] h-30 border-0 border-l-[1px] border-solid border-[#E1E3E5]"
            >
              <van-icon name="arrow-down" color="#999" />
            </div>
          </div>
          <div
            v-for="item in relationPlace"
            :key="item.id"
            class="pl-15 flex items-center"
            @click="relationPlaceClick(item)"
          >
            <div class="flex-1 h-50 flex items-center" style="border-bottom: 1px solid #E1E3E5;">
              {{ item.true_place_name }}
            </div>
          </div>
        </div>
      </template>
      <div class="bg-page h-10"></div>
    </template>
    <template #empty>
      <div class="h-full flex flex-col items-center bg-page">
        <img class="w-180 mt-80" src="@/assets/common/empty_box2.png" />
        <div class="text-theme text-14 mt-20">未找到该位置</div>
        <!-- <div
          v-if="!hideSearchRecommend && searchValue"
          class="mt-[50px] px-[60px] rounded-[4px] text-[#3d6eeb] border border-[#3d6eeb] border-solid h-[40px] flex justify-center items-center"
          @click="searchValueClick"
        >
          使用“{{ searchValue }}”
        </div> -->
      </div>
    </template>
  </PopupPicker>
</template>

<script setup>
import { ref } from "vue";
import { repairService } from "@/service";
import { Toast } from "vant";
import { useVModel } from "@vueuse/core";

import PopupPicker from "@/components/PopupPicker/Picker.vue";

const props = defineProps({
  show: { type: Boolean, default: false },
  relationPlace: { type: Array, default: () => [] },
  hideSearchRecommend: { type: Boolean, default: false }
});

const columns = ref([]);
const searchValue = ref("");
const historySearchValue = ref("");

const emit = defineEmits(["update:show", "confirm", "relation-place-click", "search-value-click"]);
const innerShow = useVModel(props, "show", emit);

const getColumns = async () => {
  try {
    const { data } = await repairService.placeTree({ search_name: searchValue.value, is_truename: "1" });
    columns.value = data.data;
  } catch (error) {
    columns.value = [];
  }
};

const onSearch = async value => {
  searchValue.value = value;
  getColumns();
};

const onConfirm = selectedValue => {
  if (selectedValue.length === 0) return Toast.fail("请选择位置");

  innerShow.value = false;
  emit("confirm", selectedValue[0]);
};

const relationPlaceClick = selectedValue => {
  innerShow.value = false;
  emit("relation-place-click", selectedValue);
};

// const searchValueClick = () => {
//   historySearchValue.value = searchValue.value;
//   emit("search-value-click", searchValue.value);
//   searchValue.value = "";
//   innerShow.value = false;
// };
const historySearchValueClick = () => {
  emit("search-value-click", historySearchValue.value);
  innerShow.value = false;
};
</script>
<style lang="less" scoped>
.search-value {
  color: #0165ff;
}
</style>
